// extracted by mini-css-extract-plugin
export default {"message":"ChatMessage_message__43GQu","my-message":"ChatMessage_my-message__o-MYX"};